import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostListener, Inject, SkipSelf, Host, ContentChild, ContentChildren, inject, Injectable, InjectionToken, NgModule, TemplateRef, ViewContainerRef, Injector, ChangeDetectorRef } from '@angular/core';
import { nativeElement, redirectTo, isNullish } from '@noda-lib/utils/handlers';
import { WINDOW } from '@noda-lib/utils/injection';
import * as i1 from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import * as i1$1 from '@angular/cdk/a11y';
let AfkDirective = /*#__PURE__*/(() => {
  class AfkDirective {
    constructor() {
      this.timeout$ = null;
      this.runCount = 0;
      this.delay = 2500;
      this.retryCount = Number.MAX_SAFE_INTEGER;
      this.disabled = false;
      this.afk = new EventEmitter();
    }
    action() {
      this.check();
    }
    ngOnDestroy() {
      this.reset();
    }
    get isCanRun() {
      return !this.disabled && this.runCount < Number(this.retryCount);
    }
    check() {
      this.isCanRun ? this.run() : this.reset();
    }
    run() {
      this.reset();
      this.timeout$ = setTimeout(() => {
        this.afk.emit();
        this.runCount++;
      }, Number(this.delay));
    }
    reset() {
      const isExistTimeout = Boolean(this.timeout$);
      if (isExistTimeout) {
        clearTimeout(this.timeout$);
        this.timeout$ = null;
      }
    }
    static {
      this.ɵfac = function AfkDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AfkDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AfkDirective,
        selectors: [["", "ngAfk", ""]],
        hostBindings: function AfkDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousemove", function AfkDirective_mousemove_HostBindingHandler() {
              return ctx.action();
            }, false, i0.ɵɵresolveDocument)("mousedown", function AfkDirective_mousedown_HostBindingHandler() {
              return ctx.action();
            }, false, i0.ɵɵresolveDocument)("keypress", function AfkDirective_keypress_HostBindingHandler() {
              return ctx.action();
            }, false, i0.ɵɵresolveDocument)("touchstart", function AfkDirective_touchstart_HostBindingHandler() {
              return ctx.action();
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          delay: [0, "ngAfk", "delay"],
          retryCount: [0, "ngAfkRetryCount", "retryCount"],
          disabled: [0, "ngAfkDisabled", "disabled"]
        },
        outputs: {
          afk: "afk"
        }
      });
    }
  }
  return AfkDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClosestDirective = /*#__PURE__*/(() => {
  class ClosestDirective {
    constructor(el$) {
      this.el$ = el$;
      this.closest = new EventEmitter();
    }
    click(e) {
      const el = nativeElement(this.el$);
      const classList = Array.from(el.classList).reduce((accum, className) => {
        return accum += `.${className}`;
      }, '');
      let parentSelectors = [classList];
      if (this.takeSelectors) {
        parentSelectors = parentSelectors.concat(this.takeSelectors);
      }
      const isContain = parentSelectors.some(selector => e.target.closest(selector));
      this.closest.emit(isContain);
    }
    static {
      this.ɵfac = function ClosestDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClosestDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ClosestDirective,
        selectors: [["", "ngClosest", ""]],
        hostBindings: function ClosestDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ClosestDirective_click_HostBindingHandler($event) {
              return ctx.click($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          takeSelectors: [0, "ngClosest", "takeSelectors"]
        },
        outputs: {
          closest: "closest"
        }
      });
    }
  }
  return ClosestDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CopyDirective = /*#__PURE__*/(() => {
  class CopyDirective {
    constructor(window) {
      this.window = window;
    }
    copy(e) {
      e.stopPropagation();
      this.window.navigator.clipboard.writeText(this.text);
    }
    static {
      this.ɵfac = function CopyDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CopyDirective)(i0.ɵɵdirectiveInject(WINDOW));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: CopyDirective,
        selectors: [["", "ngCopy", ""]],
        hostBindings: function CopyDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function CopyDirective_click_HostBindingHandler($event) {
              return ctx.copy($event);
            });
          }
        },
        inputs: {
          text: [0, "ngCopy", "text"]
        }
      });
    }
  }
  return CopyDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InsertDirective = /*#__PURE__*/(() => {
  class InsertDirective {
    constructor(document, $el) {
      this.document = document;
      this.$el = $el;
      this.position = 'afterend';
    }
    ngAfterViewInit() {
      if (!this.targetSelector) {
        throw new Error('property "ngInsertTargetSelector" must not be empty');
      }
      this.insert();
    }
    insert() {
      const $targetElement = this.document.querySelector(this.targetSelector);
      if (Boolean($targetElement)) {
        $targetElement.insertAdjacentElement(this.position, nativeElement(this.$el));
      }
    }
    static {
      this.ɵfac = function InsertDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InsertDirective)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: InsertDirective,
        selectors: [["", "ngInsert", ""]],
        inputs: {
          position: [0, "ngInsert", "position"],
          targetSelector: [0, "ngInsertTargetSelector", "targetSelector"]
        }
      });
    }
  }
  return InsertDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IntersectionDirective = /*#__PURE__*/(() => {
  class IntersectionDirective {
    constructor(document, cdr, $el) {
      this.document = document;
      this.cdr = cdr;
      this.$el = $el;
      this.visible = false;
      this.rootSelector = null;
      this.isDetect = true;
      this.rootMargin = '0px';
      this.threshold = 1;
      this.intersection = new EventEmitter();
    }
    ngAfterViewInit() {
      this.initObserver();
    }
    ngOnDestroy() {
      this.observer$.disconnect();
      this.observer$ = null;
    }
    initObserver() {
      if (!this.observer$) {
        const $rootEl = this.document.querySelector(this.rootSelector);
        this.observer$ = new IntersectionObserver(entries => {
          const [{
            isIntersecting
          }] = entries;
          this.visible = isIntersecting;
          this.intersection.emit(entries);
          if (this.isDetect) {
            this.cdr?.detectChanges();
          }
        }, {
          root: $rootEl,
          rootMargin: this.rootMargin,
          threshold: Number(this.threshold)
        });
        this.observer$.observe(nativeElement(this.$el));
      }
    }
    static {
      this.ɵfac = function IntersectionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IntersectionDirective)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef, 5), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IntersectionDirective,
        selectors: [["", "ngIntersection", ""]],
        inputs: {
          rootSelector: [0, "ngIntersection", "rootSelector"],
          isDetect: [0, "ngIntersectionDetect", "isDetect"],
          rootMargin: [0, "ngIntersectionMargin", "rootMargin"],
          threshold: [0, "ngIntersectionThreshold", "threshold"]
        },
        outputs: {
          intersection: "intersection"
        },
        exportAs: ["ngIntersectionRef"]
      });
    }
  }
  return IntersectionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LetDirective = /*#__PURE__*/(() => {
  class LetDirective {
    set ngAsync(value) {
      this.letContext.ngLet = value;
    }
    constructor(viewContainer, templateRef) {
      this.viewContainer = viewContainer;
      this.templateRef = templateRef;
      this.letContext = {
        ngLet: null
      };
    }
    ngOnInit() {
      this.viewContainer.createEmbeddedView(this.templateRef, this.letContext);
    }
    static ngTemplateContextGuard(directive, context) {
      return true;
    }
    static {
      this.ɵfac = function LetDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LetDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: LetDirective,
        selectors: [["", "ngLet", ""]],
        inputs: {
          ngAsync: [0, "ngLet", "ngAsync"]
        }
      });
    }
  }
  return LetDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LinkDirective = /*#__PURE__*/(() => {
  class LinkDirective {
    navigate() {
      if (this.url) {
        redirectTo(this.url);
      }
    }
    static {
      this.ɵfac = function LinkDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LinkDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: LinkDirective,
        selectors: [["", "ngLink", ""]],
        hostBindings: function LinkDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function LinkDirective_click_HostBindingHandler() {
              return ctx.navigate();
            });
          }
        },
        inputs: {
          url: [0, "ngLink", "url"]
        }
      });
    }
  }
  return LinkDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LocatorDirective = /*#__PURE__*/(() => {
  class LocatorDirective {
    constructor($el, renderer) {
      this.$el = $el;
      this.renderer = renderer;
    }
    ngAfterViewInit() {
      this.applyRootLocator(this.locator);
    }
    trigger() {
      this.applyRootLocator(this.locator);
    }
    applyRootLocator(locator) {
      const $rootEl = nativeElement(this.$el);
      const {
        locatorChildren,
        locatorValue
      } = locator;
      if (locatorValue) {
        this.applyLocator($rootEl, locator);
      }
      if (locatorChildren) {
        locatorChildren.forEach(({
          selector,
          locator: childrenLocator
        }) => {
          const $childEl = $rootEl.querySelector(selector);
          const isExistChild = Boolean($childEl);
          if (isExistChild) {
            this.applyLocator($childEl, childrenLocator);
          }
        });
      }
    }
    applyLocator($el, {
      locatorName,
      locatorValue
    }) {
      this.renderer.setAttribute($el, locatorName, String(locatorValue));
    }
    static {
      this.ɵfac = function LocatorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocatorDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: LocatorDirective,
        selectors: [["", "ngLocator", ""]],
        inputs: {
          locator: [0, "ngLocator", "locator"]
        },
        exportAs: ["ngLocatorRef"]
      });
    }
  }
  return LocatorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageEndpointDirective = /*#__PURE__*/(() => {
  class PageEndpointDirective {
    set _pageEndpoint(value) {
      if (value) {
        this.pageEndpoint = value;
      }
    }
    constructor(window, document, el$, renderer) {
      this.window = window;
      this.document = document;
      this.el$ = el$;
      this.renderer = renderer;
      this.pageEndpoint = ['bottom'];
      this.disabled = false;
      this.endpointElement = 'document';
      this._endpoint = new EventEmitter();
      this.scrollHandler = () => {
        if (!this.disabled) {
          this.pageEndpoint.forEach(endpoint => this[endpoint]());
        }
      };
    }
    ngOnInit() {
      this.initScrollListener();
    }
    ngOnDestroy() {
      this.unsubscribe$();
    }
    initScrollListener() {
      this.listenElement$ = this.endpointElement === 'document' ? this.document.documentElement : nativeElement(this.el$);
      const scrollElement$ = this.endpointElement === 'document' ? this.window : nativeElement(this.el$);
      this.unsubscribe$ = this.renderer.listen(scrollElement$, 'scroll', this.scrollHandler);
    }
    top() {
      const {
        scrollTop
      } = this.listenElement$;
      if (scrollTop === 0) this._endpoint.emit('top');
    }
    bottom() {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = this.listenElement$;
      const isBottom = scrollTop >= scrollHeight - clientHeight;
      if (isBottom) this._endpoint.emit('bottom');
    }
    left() {
      const {
        scrollLeft
      } = this.listenElement$;
      if (scrollLeft === 0) this._endpoint.emit('left');
    }
    right() {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = this.listenElement$;
      const isRight = scrollLeft >= scrollWidth - clientWidth;
      if (isRight) this._endpoint.emit('right');
    }
    static {
      this.ɵfac = function PageEndpointDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PageEndpointDirective)(i0.ɵɵdirectiveInject(WINDOW), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: PageEndpointDirective,
        selectors: [["", "ngPageEndpoint", ""]],
        inputs: {
          disabled: [0, "ngEndpointDisabled", "disabled"],
          endpointElement: [0, "ngEndpointElement", "endpointElement"],
          _pageEndpoint: [0, "pageEndpoint", "_pageEndpoint"]
        },
        outputs: {
          _endpoint: "endpoint"
        }
      });
    }
  }
  return PageEndpointDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectorStylesDirective = /*#__PURE__*/(() => {
  class SelectorStylesDirective {
    constructor(document, renderer) {
      this.document = document;
      this.renderer = renderer;
    }
    ngAfterViewInit() {
      this.defaultStyles = this.getCurrentStyles(Object.keys(this.styles));
      this.applyStyles(this.styles);
    }
    ngOnDestroy() {
      this.applyStyles(this.defaultStyles);
    }
    getCurrentStyles(props) {
      const el$ = this.document.querySelector(this.selector);
      return props.reduce((accum, prop) => {
        const value = getComputedStyle(el$).getPropertyValue(prop);
        accum[prop] = value;
        return accum;
      }, {});
    }
    applyStyles(styles) {
      const el$ = this.document.querySelector(this.selector);
      if (el$ && styles) {
        Object.entries(styles).forEach(([prop, value]) => {
          this.renderer.setStyle(el$, prop, value);
        });
      }
    }
    static {
      this.ɵfac = function SelectorStylesDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectorStylesDirective)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SelectorStylesDirective,
        selectors: [["", "ngSelectorStyles", ""]],
        inputs: {
          styles: [0, "ngSelectorStyles", "styles"],
          selector: [0, "ngSelector", "selector"]
        }
      });
    }
  }
  return SelectorStylesDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwitchContainCaseDirective = /*#__PURE__*/(() => {
  class SwitchContainCaseDirective {
    constructor(tpl$, viewContainer$) {
      this.tpl$ = tpl$;
      this.viewContainer$ = viewContainer$;
    }
    insert() {
      this.viewContainer$.createEmbeddedView(this.tpl$).detectChanges();
    }
    remove() {
      this.viewContainer$.clear();
    }
    isContain(value) {
      return this.values.includes(value);
    }
    static {
      this.ɵfac = function SwitchContainCaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwitchContainCaseDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SwitchContainCaseDirective,
        selectors: [["", "ngSwitchContainCase", ""]],
        inputs: {
          values: [0, "ngSwitchContainCase", "values"]
        }
      });
    }
  }
  return SwitchContainCaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwitchContainDefaultDirective = /*#__PURE__*/(() => {
  class SwitchContainDefaultDirective {
    constructor(tpl$, viewContainer$) {
      this.tpl$ = tpl$;
      this.viewContainer$ = viewContainer$;
    }
    insert() {
      this.viewContainer$.createEmbeddedView(this.tpl$).detectChanges();
    }
    remove() {
      this.viewContainer$.clear();
    }
    static {
      this.ɵfac = function SwitchContainDefaultDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwitchContainDefaultDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SwitchContainDefaultDirective,
        selectors: [["", "ngSwitchContainDefault", ""]]
      });
    }
  }
  return SwitchContainDefaultDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwitchContainDirective = /*#__PURE__*/(() => {
  class SwitchContainDirective {
    constructor() {
      this.isViewInit = false;
    }
    set _switchValue(value) {
      if (this.isViewInit && value !== this.switchValue) {
        this.repaintCases(value);
      }
      this.switchValue = value;
    }
    ngAfterViewInit() {
      this.isViewInit = true;
      this.repaintCases(this.switchValue);
    }
    repaintCases(value) {
      const caseRef$ = this.caseRefs$.find(case$ => case$.isContain(value)) || this.defaultCase$;
      this.resetCurrentCase();
      if (caseRef$) {
        this.currentCase$ = caseRef$;
        this.currentCase$.insert();
      }
    }
    resetCurrentCase() {
      if (this.currentCase$) {
        this.currentCase$.remove();
        this.currentCase$ = null;
      }
    }
    static {
      this.ɵfac = function SwitchContainDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwitchContainDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SwitchContainDirective,
        selectors: [["", "ngSwitchContain", ""]],
        contentQueries: function SwitchContainDirective_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SwitchContainDefaultDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, SwitchContainCaseDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultCase$ = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.caseRefs$ = _t);
          }
        },
        inputs: {
          _switchValue: [0, "ngSwitchContain", "_switchValue"]
        }
      });
    }
  }
  return SwitchContainDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TrackByKeyDirective = /*#__PURE__*/(() => {
  class TrackByKeyDirective {
    set ngForTrackByKey(key) {
      this.ngFor.ngForTrackBy = (index, item) => key === 'index' ? index : item[key];
    }
    constructor(ngFor) {
      this.ngFor = ngFor;
    }
    static {
      this.ɵfac = function TrackByKeyDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackByKeyDirective)(i0.ɵɵdirectiveInject(i1.NgForOf));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TrackByKeyDirective,
        selectors: [["", "ngFor", ""]],
        inputs: {
          ngForTrackByKey: "ngForTrackByKey"
        }
      });
    }
  }
  return TrackByKeyDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ViewContainerDirective = /*#__PURE__*/(() => {
  class ViewContainerDirective {
    constructor($ref) {
      this.$ref = $ref;
    }
    static {
      this.ɵfac = function ViewContainerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ViewContainerDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ViewContainerDirective,
        selectors: [["", "ngViewContainer", ""]],
        exportAs: ["viewContainerRef"]
      });
    }
  }
  return ViewContainerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function filename(url) {
  return isNullish(url) ? url : url.split('/').pop();
}
let DownloadService = /*#__PURE__*/(() => {
  class DownloadService {
    constructor() {
      this.document = inject(DOCUMENT);
      this.window = inject(WINDOW);
      this.http = inject(HttpClient);
    }
    downloadRequest(url, filename) {
      this.http.get(url, {
        responseType: 'blob'
      }).subscribe(response => {
        const {
          type
        } = response;
        const blob = new Blob([response], {
          type
        });
        const fileUrl = this.window.URL.createObjectURL(blob);
        this.download(fileUrl, filename);
      });
    }
    downloadFile(file, filename) {
      const url = this.window.URL.createObjectURL(file);
      this.download(url, filename);
    }
    download(url, filename$1 = filename(url)) {
      const link$ = this.document.createElement('a');
      link$.setAttribute('href', url);
      link$.setAttribute('download', filename$1);
      link$.click();
      link$.remove();
    }
    static {
      this.ɵfac = function DownloadService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DownloadService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DownloadService,
        factory: DownloadService.ɵfac
      });
    }
  }
  return DownloadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DOWNLOAD_URL_TRANSFORMER = new InjectionToken('DOWNLOAD_URL_TRANSFORMER', {
  providedIn: 'root',
  factory: () => url => url
});
let DownloadDirective = /*#__PURE__*/(() => {
  class DownloadDirective {
    constructor() {
      this.downloadService = inject(DownloadService);
      this.transformUrl = inject(DOWNLOAD_URL_TRANSFORMER);
      this.disabled = false;
    }
    download() {
      const {
        predicate,
        disabled,
        type,
        filename: filename$1
      } = this;
      if (predicate && !disabled) {
        switch (type) {
          case 'file':
            {
              this.downloadService.downloadFile(predicate, filename$1 || predicate.name);
              break;
            }
          case 'url':
            {
              this.downloadService.downloadRequest(predicate, filename$1 || filename(predicate));
              break;
            }
          case 'request':
            {
              this.downloadService.downloadRequest(this.transformUrl(predicate), filename$1);
              break;
            }
        }
      }
    }
    static {
      this.ɵfac = function DownloadDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DownloadDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DownloadDirective,
        selectors: [["", "ngDownload", ""]],
        hostBindings: function DownloadDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function DownloadDirective_click_HostBindingHandler() {
              return ctx.download();
            });
          }
        },
        inputs: {
          predicate: [0, "ngDownload", "predicate"],
          type: [0, "ngDownloadType", "type"],
          filename: [0, "ngDownloadName", "filename"],
          disabled: [0, "ngDownloadDisabled", "disabled"]
        },
        features: [i0.ɵɵProvidersFeature([DownloadService])]
      });
    }
  }
  return DownloadDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const imports = [LetDirective, PageEndpointDirective, SwitchContainDirective, SwitchContainCaseDirective, SwitchContainDefaultDirective, ClosestDirective, LinkDirective, SelectorStylesDirective, CopyDirective, TrackByKeyDirective, AfkDirective, IntersectionDirective, InsertDirective, LocatorDirective, ViewContainerDirective, DownloadDirective];
let UtilsDirectivesModule = /*#__PURE__*/(() => {
  class UtilsDirectivesModule {
    static {
      this.ɵfac = function UtilsDirectivesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UtilsDirectivesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UtilsDirectivesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return UtilsDirectivesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FactoryResolveDirective = /*#__PURE__*/(() => {
  class FactoryResolveDirective {
    constructor() {
      this.tpl = inject(TemplateRef);
      this.viewContainer = inject(ViewContainerRef);
      this.injector = inject(Injector);
      this.cdr = inject(ChangeDetectorRef);
      this._showState = 'hide';
    }
    get showState() {
      return this._showState;
    }
    set showState(value) {
      this._showState = value;
    }
    insertComponent(componentType) {
      this.clearContainer();
      const componentRef = this.viewContainer.createComponent(componentType, {
        index: 0,
        injector: this.injector
      });
      this.setShowState('show');
      this.cdr.detectChanges();
      return componentRef;
    }
    removeComponent() {
      this.clearContainer();
      this.cdr.detectChanges();
    }
    insertTemplate(context = null) {
      this.clearContainer();
      this.viewContainer.createEmbeddedView(this.tpl, context);
      this.setShowState('show');
      this.cdr.detectChanges();
    }
    clearContainer() {
      this.viewContainer.clear();
      this.setShowState('hide');
      this.cdr.detectChanges();
    }
    setShowState(state) {
      this.showState = state;
    }
    static {
      this.ɵfac = function FactoryResolveDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FactoryResolveDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FactoryResolveDirective,
        selectors: [["", "ngFactoryResovle", ""]]
      });
    }
  }
  return FactoryResolveDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FocusDirective = /*#__PURE__*/(() => {
  class FocusDirective {
    set _focus(value) {
      queueMicrotask(() => this.focus(value));
    }
    constructor($el, focusMonitor) {
      this.$el = $el;
      this.focusMonitor = focusMonitor;
    }
    focus(isFocused) {
      const $el = nativeElement(this.$el);
      if (isFocused) {
        this.focusMonitor.focusVia($el, 'program');
        nativeElement(this.$el).click(); // ! Убрать после того, как откажемся от @angular/material
      }
    }
    static {
      this.ɵfac = function FocusDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.FocusMonitor));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FocusDirective,
        selectors: [["", "ngFocus", ""]],
        inputs: {
          _focus: [0, "ngFocus", "_focus"]
        }
      });
    }
  }
  return FocusDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EnHtmlLocator = /*#__PURE__*/function (EnHtmlLocator) {
  EnHtmlLocator["DEFAULT_KEY"] = "data-locator";
  return EnHtmlLocator;
}(EnHtmlLocator || {});
class LocatorItem {
  constructor(locatorValue, locatorName = EnHtmlLocator.DEFAULT_KEY, locatorChildren = null) {
    this.locatorValue = locatorValue;
    this.locatorName = locatorName;
    this.locatorChildren = locatorChildren;
  }
  set(key, value) {
    this[key] = value;
    return this;
  }
}
let ToggleCssClassDirective = /*#__PURE__*/(() => {
  class ToggleCssClassDirective {
    constructor(el$, renderer) {
      this.el$ = el$;
      this.renderer = renderer;
    }
    ngOnChanges(changes) {
      const {
        ngToggleClass: {
          previousValue,
          currentValue,
          firstChange
        }
      } = changes;
      this.removeClassName(previousValue);
      if (Boolean(currentValue)) {
        firstChange ? setTimeout(() => {
          this.addClassName(currentValue);
        }) : this.addClassName(currentValue);
      }
    }
    removeClassName(className) {
      const el$ = nativeElement(this.el$);
      this.renderer.removeClass(el$, className);
    }
    addClassName(className) {
      const el$ = nativeElement(this.el$);
      this.renderer.addClass(el$, className);
    }
    static {
      this.ɵfac = function ToggleCssClassDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ToggleCssClassDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ToggleCssClassDirective,
        selectors: [["", "ngToggleClass", ""]],
        inputs: {
          ngToggleClass: "ngToggleClass"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return ToggleCssClassDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AfkDirective, ClosestDirective, CopyDirective, DOWNLOAD_URL_TRANSFORMER, DownloadDirective, EnHtmlLocator, FactoryResolveDirective, FocusDirective, InsertDirective, IntersectionDirective, LetDirective, LinkDirective, LocatorDirective, LocatorItem, PageEndpointDirective, SelectorStylesDirective, SwitchContainCaseDirective, SwitchContainDefaultDirective, SwitchContainDirective, ToggleCssClassDirective, TrackByKeyDirective, UtilsDirectivesModule, ViewContainerDirective };
